import React, { useState } from 'react';
import cn from 'classnames';

import { Checkbox, ButtonTs } from '@lt/components';
import { StyledToggleIcon } from '@lt/components/components/AbstractToggler';
import FilterLabel from '../FilterLabel';

import styles from './multipleChoiceFilter.module.css';
import type { IMultipleChoiceFilter as Props } from './types';

const MultipleChoiceFilter = ({
  items,
  onChange,
  visibleItems = Infinity,
  expandLabel = 'Показать все',
  className = '',
  LabelComponent = FilterLabel,
  isMobile = false,
}: Props) => {
  const showToggle = items.length > visibleItems;
  const [itemsToShow, setItemsToShow] = useState(
    Math.min(items.length, visibleItems),
  );
  const isClamped = itemsToShow < items.length;
  return (
    <div className={className}>
      {items.slice(0, itemsToShow).map((item) => {
        const {
          id,
          path,
          selected,
          disabled,
          hotel_count: count,
          min_price: price,
        } = item;
        return (
          <Checkbox
            className={cn(styles.checkbox, {
              [styles.mobileCheckbox]: isMobile,
            })}
            options={{ enableUncheckOnDisabled: true }}
            key={`${path || 'filter'}-${id}`}
            id={id}
            checked={selected}
            disabled={disabled}
            onClick={() => onChange({ ...item, selected: !selected })}
          >
            <LabelComponent
              {...item}
              isMobile={isMobile}
              count={count}
              price={price}
            />
          </Checkbox>
        );
      })}
      {showToggle && (
        <ButtonTs
          className={cn(styles.toggleButton, {
            [styles.mobileToggleButton]: isMobile,
          })}
          variant="functional"
          onClick={() =>
            setItemsToShow(isClamped ? items.length : visibleItems)
          }
        >
          {isClamped ? <span>{expandLabel}</span> : <span>Скрыть</span>}
          <StyledToggleIcon isOpen={!isClamped} />
        </ButtonTs>
      )}
    </div>
  );
};

export default React.memo(MultipleChoiceFilter);
